module.exports = __webpack_public_path__ + "static/media/banner6.7f2034c3.jpg";